import React from 'react';
import PropTypes from 'prop-types';

import './dragDrop.scss';

export default class DragDrop extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isValidDrop = false;
    this.dragged = null;
    this.over = null;
    this.state = {
      optionList: this.props.options || []
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.options !== this.props.options) {
      this.setState({
        optionList: this.props.options
      })
    }
  }

  dragStart = (e) => {
    this.isValidDrop = false;
    this.initialOrder = [...this.state.optionList];
    this.dragged = e.currentTarget;
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', this.dragged);
  }

  swapElements = () => {
    const data = [...this.state.optionList];
    let fromIndex = -1;
    let toIndex = -1;
    data.forEach((node, index) => {
      if (node?.dataIndex === this.dragged?.dataset?.id) {
        fromIndex = index;
      }
      if (node?.dataIndex === this.over) {
        toIndex = index;
      }
    })
    const tempNode = data[fromIndex];
    data[fromIndex] = data[toIndex];
    data[toIndex] = tempNode;
    return data;
  }

  restoreOrder = () => {
    this.setState({
      optionList: this.initialOrder
    })
  }

  dragEnd = () => {
    const { reArrangeCallback } = this.props;
    if (this.isValidDrop) {
      const newList = this.swapElements();
      this.setState({
        optionList: newList
      }, () => {
        reArrangeCallback && reArrangeCallback(this.state.optionList);
      })
    } else {
      this.restoreOrder();
    }
  }

  onDrop = (e) => {
    const { containerId } = this.props;
    const container = document.querySelector(`#${containerId} .listContainer`);
    if (container.contains(e.target)) {
      this.isValidDrop = true;
    } else {
      this.isValidDrop = false;
    }
  }

  dragOver = (e, key) => {
    e.preventDefault();
    this.over = key;
    const newList = this.swapElements();
    this.setState({
      optionList: newList
    })
  }

  emptyFunction = () => {};

  getOptionsList = () => {
    const { optionList } = this.state;
    const { customTemplate } = this.props;
    return (
      optionList && optionList.map((node) => {
        
        return (
          <li
            className={`drag-option ${this.props.noDrag ? 'no-drag' : ''}`}
            data-id={node?.dataIndex}
            key={node?.dataIndex}
            //the below code is to make the available columns not dragabble
            {...(!this.props.noDrag && {
              onDrop : node?.isDraggable ? this.onDrop : this.emptyFunction,
              draggable : node?.isDraggable,
              onDragEnd : node?.isDraggable ? this.dragEnd : this.emptyFunction,
              onDragOver : node?.isDraggable ? (e) => this.dragOver(e, node?.dataIndex) : this.emptyFunction,
              onDragStart : node?.isDraggable ? this.dragStart : this.emptyFunction
            })}
          >
            {customTemplate(node)}
          </li>
        )
      })
    );
  };

  render() {
    const { customClass, containerId } = this.props;

    return (
      <div className={`dragList ${customClass}`} id={containerId} >
        <ul className='listContainer'>
          {this.getOptionsList()}
        </ul>
      </div>
    )
  }
}

DragDrop.propTypes = {
  containerId: PropTypes.string.isRequired, // it is required to find out the droppable area
  customClass: PropTypes.string,
  options: PropTypes.array.isRequired,
  reArrangeCallback: PropTypes.func,
};


DragDrop.defaultProps = {
  customClass: '',
  options: [],
};